import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router";

import { useUsuario } from "@/features/acceso/api";
import { hasSeenWelcome, markWelcomeSeen, phonePlatform } from "./device";

/** Vive dentro de AppShell: Guard ya comprobó sesión y cambio obligatorio de clave. */
export function WelcomeGate() {
  const user = useUsuario().data;
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    if (!user || user.must_change_password || phonePlatform() === "desktop" || hasSeenWelcome()) return;
    markWelcomeSeen();
    if (location.pathname !== "/bienvenida") navigate("/bienvenida", { replace: true });
  }, [user, location.pathname, navigate]);
  return null;
}
